import { useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { CheckCircle, Clock, ArrowLeft } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const WaitlistPage = () => {
  const [form, setForm] = useState({ name: "", phone: "", email: "", preferred_style: "", preferred_day: "Saturday" });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) { toast.error("Name and phone are required"); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/waitlist`, form);
      setSubmitted(true);
    } catch { toast.error("Something went wrong"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-brand-bg flex flex-col" data-testid="waitlist-page">
      <header className="border-b border-brand-border bg-brand-surface px-6 py-4 flex items-center justify-between">
        <Link to="/" className="font-serif text-xl text-brand-text">Afro <span className="text-brand-gold">Magic</span></Link>
        <Link to="/" className="flex items-center gap-1 font-sans text-xs text-brand-text-muted hover:text-brand-gold"><ArrowLeft size={14} /> Back</Link>
      </header>

      <div className="flex-1 flex items-center justify-center px-6 py-12">
        {submitted ? (
          <div className="text-center max-w-sm" data-testid="waitlist-success">
            <CheckCircle size={48} className="text-brand-gold mx-auto mb-4" />
            <h2 className="font-serif text-2xl text-brand-text mb-2">You're on the Waitlist!</h2>
            <p className="font-sans text-sm text-brand-text-muted mb-4">We'll contact you as soon as a weekend slot opens up.</p>
            <p className="font-sans text-xs text-brand-text-muted">(313) 484-7307 | afromagicbraiding.shop</p>
          </div>
        ) : (
          <div className="w-full max-w-md">
            <div className="text-center mb-8">
              <div className="inline-flex items-center gap-2 bg-brand-gold/10 border border-brand-gold/30 px-4 py-1.5 mb-4">
                <Clock size={14} className="text-brand-gold" />
                <span className="font-sans text-xs text-brand-gold font-semibold">WEEKEND SPOTS FILL FAST</span>
              </div>
              <h1 className="font-serif text-3xl text-brand-text">Weekend Waitlist</h1>
              <p className="font-sans text-sm text-brand-text-muted mt-2">Get notified when a weekend appointment opens up</p>
            </div>
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="waitlist-form">
              <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your Name *" data-testid="waitlist-name" className="bg-brand-surface border-brand-border text-brand-text rounded-none h-12" />
              <Input type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="Phone Number *" data-testid="waitlist-phone" className="bg-brand-surface border-brand-border text-brand-text rounded-none h-12" />
              <Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email (optional)" className="bg-brand-surface border-brand-border text-brand-text rounded-none h-12" />
              <Select value={form.preferred_style} onValueChange={(val) => setForm({ ...form, preferred_style: val })}>
                <SelectTrigger className="bg-brand-surface border-brand-border text-brand-text rounded-none h-12"><SelectValue placeholder="Preferred Style (optional)" /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="Knotless Braids">Knotless Braids</SelectItem>
                  <SelectItem value="Box Braids">Box Braids</SelectItem>
                  <SelectItem value="Fulani Braids">Fulani Braids</SelectItem>
                  <SelectItem value="Boho Braids">Boho Braids</SelectItem>
                  <SelectItem value="Kinky Twists">Kinky Twists</SelectItem>
                  <SelectItem value="Faux Locs">Faux Locs</SelectItem>
                  <SelectItem value="Cornrows">Cornrows</SelectItem>
                  <SelectItem value="Other">Other</SelectItem>
                </SelectContent>
              </Select>
              <Select value={form.preferred_day} onValueChange={(val) => setForm({ ...form, preferred_day: val })}>
                <SelectTrigger className="bg-brand-surface border-brand-border text-brand-text rounded-none h-12"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="Saturday">Saturday</SelectItem>
                  <SelectItem value="Sunday">Sunday</SelectItem>
                  <SelectItem value="Either">Either day works</SelectItem>
                </SelectContent>
              </Select>
              <button type="submit" disabled={loading} data-testid="waitlist-submit" className="w-full py-3 bg-brand-gold text-black font-sans font-semibold text-sm hover:bg-brand-gold-light transition-colors disabled:opacity-60">
                {loading ? "Joining..." : "Join the Waitlist"}
              </button>
              <p className="font-sans text-[10px] text-brand-text-muted text-center">By joining, you agree to receive SMS updates. Reply STOP to opt out.</p>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default WaitlistPage;
